document.addEventListener("DOMContentLoaded", function (event) {
	const tabStyles = [
		{
			selector: ".tabs-styleOne",
			childSelector: ".tab-dot-icon",
			activeClass: "text-secondary",
			inactiveClass: "text-body",
			childActiveClass: "bg-secondary",
			childInactiveClass: "bg-semiGray",
		},
		{
			selector: ".tabs-styleTwo",
			activeClass: "text-primary border-primary",
			inactiveClass: "text-darkGray border-white",
		},
		{
			selector: ".tabs-styleThree",
			activeClass: "text-primary border-primary",
			inactiveClass: "text-darkGray border-darkGray",
		},
	];

	let currentTabIndex = 0;

	function initializeTabs() {
		// Ensure only the first tab is visible on initial load
		tabStyles.forEach((style) => {
			const tabContentBlocks = document.querySelectorAll(`${style.selector} .tab-content-block`);
			const legacyContents = document.querySelectorAll(`${style.selector} div[id^="content-tab-"]`);
			
			// Handle InnerBlocks tab-content blocks
			tabContentBlocks.forEach((block, index) => {
				const tabIndex = parseInt(block.getAttribute('data-tab-index'), 10);
				if (tabIndex === 0) {
					block.style.display = "block";
					block.classList.remove("hidden");
				} else {
					block.style.display = "none";
					block.classList.add("hidden");
				}
			});
			
			// Handle legacy tab content
			legacyContents.forEach((content, index) => {
				if (index === 0) {
					content.classList.remove("hidden");
					content.style.display = "block";
				} else {
					content.classList.add("hidden");
					content.style.display = "none";
				}
			});
		});
		
		// Set the initial tab button states
		updateTabClasses(0);
	}

	function updateTabClasses(newIndex) {
		tabStyles.forEach((style) => {
			const tabs = document.querySelectorAll(
				`${style.selector} button[id^="tab-"]`,
			);
			const contents = document.querySelectorAll(
				`${style.selector} div[id^="content-tab-"]`,
			);

			if (tabs.length > 0) {
				tabs.forEach((t, index) => {
					if (index === newIndex) {
						t.classList.remove(...style.inactiveClass.split(" "));
						t.classList.add(...style.activeClass.split(" "));
						if (t.querySelector(style.childSelector)) {
							t.querySelector(style.childSelector).classList.remove(...style.childInactiveClass.split(" "));
							t.querySelector(style.childSelector).classList.add(...style.childActiveClass.split(" "));
						}
					} else {
						t.classList.remove(...style.activeClass.split(" "));
						t.classList.add(...style.inactiveClass.split(" "));
						if (t.querySelector(style.childSelector)) {
							t.querySelector(style.childSelector).classList.remove(...style.childActiveClass.split(" "));
							t.querySelector(style.childSelector).classList.add(...style.childInactiveClass.split(" "));
						}
					}
				});

				// Handle both old tab content structure and new InnerBlocks structure
				contents.forEach((content, index) => {
					if (index === newIndex) {
						content.classList.remove("hidden");
						content.style.display = "block";
					} else {
						content.classList.add("hidden");
						content.style.display = "none";
					}
				});

				// Handle InnerBlocks tab-content blocks
				const tabContentBlocks = document.querySelectorAll(`${style.selector} .tab-content-block`);
				tabContentBlocks.forEach((block, index) => {
					const tabIndex = parseInt(block.getAttribute('data-tab-index'), 10);
					if (tabIndex === newIndex) {
						block.style.display = "block";
						block.classList.remove("hidden");
					} else {
						block.style.display = "none";
						block.classList.add("hidden");
					}
				});
			}
		});
	}

	// Smooth scroll to active tab content (supports new InnerBlocks and legacy markup)
	function scrollToTabContent(tabIndex) {
		requestAnimationFrame(() => {
			let target =
				document.querySelector(`.tab-content-block[data-tab-index="${tabIndex}"]`) ||
				document.querySelector(`#content-tab-${tabIndex}`);
			if (!target) return;

			const adminBar = document.getElementById('wpadminbar');
			const offset = (adminBar ? adminBar.offsetHeight : 0) + 100; // extra spacing
			const top = target.getBoundingClientRect().top + window.scrollY - offset;
			window.scrollTo({ top, behavior: 'smooth' });
		});
	}
	
	function switchTab(direction) {
		// Handle both old structure and new InnerBlocks structure
		const tabs = document.querySelectorAll('.tab-content, .tab-content-block');
		let activeTabIndex = currentTabIndex;
	
		if (direction === 'next') {
			activeTabIndex = (activeTabIndex + 1) % tabs.length;
		} else {
			activeTabIndex = (activeTabIndex - 1 + tabs.length) % tabs.length;
		}

		currentTabIndex = activeTabIndex;
		updateTabClasses(activeTabIndex);
		scrollToTabContent(activeTabIndex); // added
	}

	tabStyles.forEach((style) => {
		const tabs = document.querySelectorAll(
			`${style.selector} button[id^="tab-"]`,
		);

		if (tabs.length > 0) {
			tabs.forEach((tab, index) => {
				tab.addEventListener("click", () => {
					currentTabIndex = index;
					updateTabClasses(currentTabIndex);
					scrollToTabContent(currentTabIndex); // added
				});
			});
		}
	});

	// Initialize tabs on page load to ensure correct initial state
	initializeTabs();

	window.switchTab = switchTab;
});